import htmx from "htmx.org";
import "./fileuploads";
import "./document-upload";
import "./menu";
import "./formdialogs";
import Alpine from "alpinejs";
import initAlpineComponents from "./alpinecomponents";
import formComponents from "./alpine/forms";
import alpineDebugger from "./alpine/debugger";

window.htmx = htmx;
window.Alpine = Alpine;

document.addEventListener("alpine:init", () => {
  initAlpineComponents(Alpine);
  formComponents(Alpine);
  alpineDebugger(Alpine);
});

Alpine.start();

window.addEventListener("load", () => {
  checkForm();
  initExpandableLists();
  initCheckAllToggle();
  handleOriginTracking();
  selectInputTextOnFocus();
  showSDAPopup();
  preventButtonScroll();
});

function selectInputTextOnFocus() {
  document.querySelectorAll("input").forEach((input) => {
    input.addEventListener("focus", function () {
      this.select();
    });
  });
}

function showSDAPopup() {
  const key = "sda-intro-shown";
  const el = document.querySelector("#sda-video-intro");
  if(!el) return;

  const shown = window.localStorage.getItem(key);
  if(!shown || shown === false) {
    window.localStorage.setItem(key, true);
    el.showModal();
  }
}

// Needs to init event listenere on swap since most element are not available on content loaded
document.addEventListener("htmx:afterSwap", () => {
  checkForm();
  initCheckAllToggle();
  preventButtonScroll();
});

function checkForm() {
  if (document.querySelector("form")) {
    // scroll to first error
    const err = document.querySelector(".error");
    if (err) err.scrollIntoView();

    const inputs = document.querySelectorAll("input[data-err]");
    inputs.forEach(function (inp) {
      ["blur", "input"].forEach(function (evt) {
        inp.addEventListener(evt, removeError);
      });
    });

    const selects = document.querySelectorAll("select[data-err]");
    selects.forEach(function (sel) {
      sel.addEventListener("change", removeError);
    });
  }
}

function removeError(evt) {
  const el = evt.srcElement;
  const dataErr = el.getAttribute("data-err");
  const err = document.querySelector(`.err-${dataErr}`);
  if (err) err.remove();
  const parent = el.closest(".input.error");
  if (parent) parent.classList.remove("error");
}

function money(v) {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "€",

    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(v);
}

function initExpandableLists() {
  const expandableLists = document.querySelectorAll(".list.expandable");
  if (expandableLists.length == 0) {
    return;
  }

  const expandButtons = [];
  const expandableContents = [];
  for (let i = 0; i < expandableLists.length; i++) {
    const listItems = expandableLists[i].querySelectorAll(".list-item");
    if (listItems.length == 0) {
      continue;
    }
    for (let j = 0; j < listItems.length; j++) {
      const expandBtn = listItems[j].querySelector(".main-content .icon");
      if (!expandBtn) {
        continue;
      }
      expandButtons.push(expandBtn);

      const expandableContent =
        listItems[j].querySelector(".list-item-content");
      if (!expandableContent) {
        continue;
      }
      expandableContents.push(expandableContent);

      expandBtn.addEventListener("click", () => {
        expandableContent.classList.toggle("collapsed");
        const isOpen = !expandableContent.classList.contains("collapsed");
        expandBtn.classList.toggle("icon-arrows-down", !isOpen);
        expandBtn.classList.toggle("icon-arrows-up", isOpen);

        // array of buttons and content will allways be aligned (btn[1] is related to content[1])
        expandButtons.forEach((btn, idx) => {
          if (
            btn != expandBtn &&
            !expandableContents[idx].classList.contains("collapsed")
          ) {
            expandableContents[idx].classList.add("collapsed");
            btn.classList.add("icon-arrows-down");
            btn.classList.remove("icon-arrows-up");
          }
        });
      });
    }
  }
}

// See uc_payment.templ for usage
function initCheckAllToggle() {
  const allToggles = document.querySelectorAll(".all-toggle");
  if (allToggles.length == 0) {
    return;
  }
  const toggleButtons = document.querySelector("#toggle-buttons");

  for (let i = 0; i < allToggles.length; i++) {
    const datafor = allToggles[i].getAttribute("data-for");

    const checkboxes = document.querySelectorAll("." + datafor);
    if (checkboxes.length == 0) {
      continue;
    }

    allToggles[i].addEventListener("change", () => {
      const checked = allToggles[i].checked;
      for (let j = 0; j < checkboxes.length; j++) {
        checkboxes[j].checked = checked;
      }

      if (toggleButtons) {
        toggleButtons.classList.toggle("hidden", !checked);
      }
    });

    for (let j = 0; j < checkboxes.length; j++) {
      checkboxes[j].addEventListener("change", () => {
        let allTrue = true;
        let anyTrue = false;
        for (let k = 0; k < checkboxes.length; k++) {
          if (!checkboxes[k].checked) {
            allTrue = false;
            allToggles[i].checked = false;
          } else {
            anyTrue = true;
          }
        }
        allToggles[i].checked = allTrue;

        if (toggleButtons) {
          toggleButtons.classList.toggle("hidden", !anyTrue);
        }
      });
    }
  }
}

function handleOriginTracking() {
  const el = document.querySelector(".subscription-choice");
  if(!el) {
    return;
  }

  let origin = "unknown";
  let redirect = "/";
  if (typeof URLSearchParams !== 'undefined') {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.origin != '') origin = params.o;
    if (params.r != '') redirect = params.r;
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  const originElem = el.querySelector("#origin");
  if (originElem && originElem.value === "") {
    originElem.value = origin;
  }
  el.querySelector("#redirect").value = redirect;
}

/** Prevents the page from scrolling to the bottom when clicking any buttons (except for the "Save" ones). */
function preventButtonScroll() {
  const buttons = document.querySelectorAll('button[hx-post]:not([type="submit"])');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      // Save current scroll position
      const savedScrollPosition = window.pageYOffset;

      // Restore scroll position after HTMX swap completes
      const restoreScroll = () => {
        window.scrollTo(0, savedScrollPosition);
        document.removeEventListener('htmx:afterSwap', restoreScroll);
      };

      // Listen for the next HTMX swap and restore position
      document.addEventListener('htmx:afterSwap', restoreScroll, { once: true });
    });
  });
}
